import angular from 'angular'

import { AssignOnboardingEmployeeModalComponent } from './assign-onboarding-employee/assign-onboarding-employee-modal.component';
import { EditOnboardingApplicationComponent } from './edit-onboarding-application/edit-onboarding-application.component';
import { EditOnboardingApplicationModalComponent } from './edit-onboarding-application/edit-onboarding-application-modal.component';
import { EditOnboardingApplicationStatusModalComponent } from './edit-onboarding-application-status/edit-onboarding-application-status-modal.component';
import { OnboardingApplicationDetailComponent } from './onboarding-application-detail/onboarding-application-detail.component';
import { OnboardingApplicationDetailModalComponent } from './onboarding-application-detail/onboarding-application-detail-modal.component';
import { OnboardingApplicationsListComponent } from './onboarding-applications-list/onboarding-applications-list.component';
import { TransferOnboardingApplicationModalComponent } from './transfer-onboarding-application/transfer-onboarding-application.component';
import { EditOnboardingDocumentModalComponent } from './edit-onboarding-document/edit-onboarding-document-modal.component';
import { AddToRosterModule } from './add-to-roster/add-applicant-to-roster.module';

export const OnboardingApplicationModule = angular
    .module("apex.mainApp.onboarding.application", [
        AddToRosterModule
    ])
    .component("apexAssignOnboardingEmployeeModal", AssignOnboardingEmployeeModalComponent)
    .component("apexEditOnboardingApplication", EditOnboardingApplicationComponent)
    .component("apexEditOnboardingApplicationModal", EditOnboardingApplicationModalComponent)
    .component("apexEditOnboardingApplicationStatusModal", EditOnboardingApplicationStatusModalComponent)
    .component("apexEditOnboardingDocumentModal", EditOnboardingDocumentModalComponent)
    .component("apexOnboardingApplicationDetail", OnboardingApplicationDetailComponent)
    .component("apexOnboardingApplicationDetailModal", OnboardingApplicationDetailModalComponent)
    .component("apexOnboardingApplicationsList", OnboardingApplicationsListComponent)
    .component("apexTransferOnboardingApplication", TransferOnboardingApplicationModalComponent)
    .name
